import React from "react"
import './index.scss'
import {Link} from "react-router-dom";
import pJson from '../../../package.json'
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../../components/language/LanguageSelector';

const FooterOne = () => {
    const { t } = useTranslation('common');

    return (
        <div className='footer footer-one' style={{height: '100%'}}>
            <div className="footer-content">
                <div className="top">
                    <div className="column column-1">
                        <Link to='/' className='logo-container'>
                            <img
                                src={'https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/logo.png'}
                                alt="Happy Gastro Logo"
                                className='logo-img'
                            />
                            <h3 className='t-l'>
                                Happy Gastro
                            </h3>
                        </Link>
                        <p>
                            {t('footer.description')}
                        </p>
                        <div className="links">
                            <a href="mailto:info@happygastro.hu">
                                <i className="bx bx-mail-send"/>
                            </a>
                            <a href="tel:+3613009105">
                                <i className="bx bx-phone"/>
                            </a>
                            <a href="https://www.facebook.com/gastro.happy" target='_blank' rel="noreferrer">
                                <i className="bx bxl-facebook"/>
                            </a>
                        </div>
                        <div className="aszf">
                            <Link to={'/aszf'}>
                                {t('footer.terms')}
                            </Link>
                        </div>
                        <div className="adatkezelesi-tajekoztato">
                            <Link to={'/adatkezelesi-tajekoztato'}>
                                {t('footer.privacy')}
                            </Link>
                        </div>
                        <div className="karrier">
                            <Link to={'/karrier'}>
                                {t('footer.career')}
                            </Link>
                        </div>
                        <div className="partner-program">
                            <Link to={'/partner-program'}>
                                {t('footer.partnerProgram')}
                            </Link>
                        </div>
                        <div className="gyik">
                            <Link to={'/kapcsolat/gyik'}>
                                {t('footer.faq')}
                            </Link>
                        </div>
                        <div className="integrations">
                            <Link to={'/integraciok'}>
                                {t('footer.integrations')}
                            </Link>
                        </div>
                        <br/>
                    </div>
                    <div className="column column-3">
                        <h3>
                            {t('footer.contacts')}
                        </h3>
                        <div className="links">
                            <a href="https://goo.gl/maps/T3hRZM87rtbpGRiY7" target={'_blank'} rel="noreferrer">
                                <i className="bx bx-map-pin"/>
                                <strong>
                                    {t('footer.address')}
                                </strong>
                            </a>
                            <a href="tel:+3613009105">
                                <i className="bx bx-phone-call"/>
                                <strong>
                                    +36 (1) 300 9105
                                </strong>
                            </a>
                            <a href="mailto:info@happygastro.hu">
                                <i className="bx bx-info-circle"/>
                                <strong>
                                    info@happygastro.hu
                                </strong>
                            </a>
                            <a href="mailto:support@happygastro.hu">
                                <i className="bx bx-wrench"/>
                                <strong>
                                    support@happygastro.hu
                                </strong>
                            </a>
                        </div>

                        <a href="https://play.google.com/store/apps/details?id=org.happysolutions.app&referrer=utm_source=footer-hg" target="_blank" rel="noopener noreferrer">
                            <img
                                src="/GetItOnGooglePlay_Badge.png"
                                alt="Get it on Google Play"
                                style={{ maxWidth: '200px', minHeight: '0.3in', margin: 15 }}
                            />
                        </a>

                        <LanguageSelector />
                    </div>
                </div>
                <div className="bottom">
                    <strong>{t('footer.copyright', { year: new Date().getFullYear() })}</strong>
                    <div className='happy'>
                        <strong>
                            {t('footer.operatedBy')}
                        </strong>
                        <div className="watermark">
                            <img src={'https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/logo.png'}
                                 alt="Happy Gastro Éttermi szoftver"/>
                            <span ><a  style={{color: '#f1b44c'}} href="https://www.happysolution.hu/">
                            Happy Solutions</a><sup style={{fontSize: '7px', color: '#f1b44c'}}>™</sup>
                        </span>
                        </div>
                        <strong>
                            {t('footer.software')}
                        </strong>
                        <strong>
                            !
                        </strong>
                    </div>
                    <small>v{pJson.version}</small>
                </div>
            </div>
        </div>
    )
}

export default FooterOne;
